module.exports = __webpack_public_path__ + "img/icon.d6597896.png";